/* A storefront-only recreation of FUTPilot 1.1.3's Saved Profiles menu. */
(function () {
  'use strict';

  const PREFIX = 'futpilot-preview-profiles-1.1.3:';
  const MAX_NAME = 80;
  const ICONS = { add: '\ue0c3', open: '\ue092', save: '\ue0c4', copy: '\ue062', confirm: '\ue02f', close: '\ue0b8', delete: '\ue093', profile: '\ue0c2' };
  const ADJECTIVES = ['wacky', 'quirky', 'zany', 'goofy', 'funky', 'silly', 'witty', 'bizarre'];
  const NOUNS = ['goalkeeper', 'striker', 'midfielder', 'defender', 'formation', 'tactics', 'penalty', 'hat-trick'];
  // The published v1.1.3 profile blob has one name plus mode-specific settings.
  const SNIPING_KEYS = [
    'snipingSectionModes', 'sniperDurationMinValue', 'sniperDurationMaxValue', 'sniperDurationUnit',
    'timeBetweenSearchesMin', 'timeBetweenSearchesMax', 'cardBoughtLimit', 'cardSeenLimit',
    'searchLimit', 'searchResultLimit', 'searchWithoutResultsLimit', 'minimumCoinBalance',
    'maxBuyNowPriceLimit', 'maxMinBuyNowPrice', 'doRandomTaskBeforeBreak',
    'breakTaskClearSoldItems', 'breakTaskRelistExpiredItems', 'breakTaskRefreshCoinBalance',
    'priceRangeBreakEnabled', 'priceRangeIncludeSnipedPlayers', 'selectionChoice',
    'defaultFollowUpAction', 'followUpActionRules', 'snipingFilter', 'snipingFilterPlayerRating',
    'skipBuyRules', 'breakFrequencyMin', 'breakFrequencyMax', 'breakFrequencyUnit',
    'breakDurationMin', 'breakDurationMax', 'breakDurationUnit', 'buyAttempts',
    'postWinDelaySeconds', 'transferListStateNotification', 'filterRotatedNotification',
    'shouldHideImages', 'enableHeadlessBuy', 'headlessVerboseNotifications', 'headlessMode',
    'breakExecuteFollowUpActionRules'
  ];

  function mode(kind) { return kind === 'bidding' ? 'bidding' : 'sniping'; }
  function keyFor(kind) { return PREFIX + mode(kind); }
  function read(kind) {
    try {
      const saved = JSON.parse(localStorage.getItem(keyFor(kind)) || '{}');
      return {
        profiles: Array.isArray(saved.profiles) ? saved.profiles.filter(item => item && typeof item.key === 'string' && typeof item.name === 'string' && item.data && typeof item.data === 'object' && !Array.isArray(item.data)) : [],
        activeKey: typeof saved.activeKey === 'string' ? saved.activeKey : null,
        activeData: saved.activeData && typeof saved.activeData === 'object' && !Array.isArray(saved.activeData) ? saved.activeData : null
      };
    } catch (_) { return { profiles: [], activeKey: null, activeData: null }; }
  }
  function write(kind, value) {
    try { localStorage.setItem(keyFor(kind), JSON.stringify(value)); }
    catch (_) { throw new Error('Could not save this demo profile on this device.'); }
  }
  function clone(value) {
    try { return value === undefined ? {} : JSON.parse(JSON.stringify(value)); }
    catch (_) { return {}; }
  }
  function profilePayload(data, kind) {
    const result = clone(data);
    if (mode(kind) === 'sniping') delete result.defaults;
    return result;
  }
  function nameOf(value) {
    const name = String(value == null ? '' : value).trim();
    if (!name) throw new Error('Enter a profile name.');
    if (name.length > MAX_NAME) throw new Error('Use 80 characters or fewer.');
    return name;
  }
  function randomName() {
    return ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)] + ' ' + NOUNS[Math.floor(Math.random() * NOUNS.length)];
  }
  function identifier() {
    return globalThis.crypto && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }
  function stripFilter(data, kind) {
    const result = clone(data);
    if (kind === 'bidding') return { __withoutFilter: true };
    delete result.filter;
    delete result.filters;
    delete result.snipingFilter;
    delete result.snipingFilterPlayerRating;
    if (result.__extensionValues) { result.__extensionValues.snipingFilter = null; result.__extensionValues.snipingFilterPlayerRating = null; }
    if (Array.isArray(result.profiles)) result.profiles = result.profiles.map(item => {
      const draft = { ...item, imported: false, playerName: '', rating: '', maxBin: '' };
      delete draft.sourceFilter;
      return draft;
    });
    return result;
  }
  function previewFilterFrom(source, rating, index) {
    const base = window.FutpilotPreviewSniping?.defaultState?.().profiles?.[0] || {};
    const filter = source && typeof source === 'object' ? source : {};
    const action = filter.followUpAction && typeof filter.followUpAction === 'object' ? filter.followUpAction : null;
    return {
      ...clone(base),
      id: identifier(),
      name: String(filter.name || `Filter ${index + 1}`),
      enabled: filter.enabled !== false,
      imported: filter.schemaVersion === 2 && Array.isArray(filter.prices) && filter.prices.length === 4 && filter.searchImportPending !== true,
      playerName: String(filter.playerName || ''),
      rating: rating ?? '',
      maxBin: filter.prices?.[3] ?? '',
      purchaseMode: filter.purchaseMode || 'live',
      buyLimit: filter.buyLimit ?? 0,
      buyLimitAction: filter.buyLimitAction || 'rotate',
      purchaseRules: Array.isArray(filter.purchaseRules) ? clone(filter.purchaseRules) : [],
      futbinAction: filter.futbinAction || 'off',
      futbinFallbackPrice: filter.futbinFallbackPrice ?? 0,
      followUpAction: action ? String(action.type) : '',
      startPrice: action?.startPrice ?? 0,
      buyNowPrice: action?.buyNowPrice ?? 0,
      followUpRules: Array.isArray(filter.followUpRules) ? clone(filter.followUpRules) : [],
      rotateMinutes: filter.rotateAfter?.minutes ?? 0,
      selectionChoice: filter.selectionChoice || 'cheapest',
      buyAttempts: filter.buyAttempts ?? 0,
      postWinDelaySeconds: filter.postWinDelaySeconds ?? 0,
      freshnessMode: filter.freshnessMode || 'run',
      resetPrice: filter.maxMinBuyNowPrice ?? 0,
      freshnessMaxBin: filter.maxBuyNowPriceLimit ?? 0,
      sourceFilter: clone(filter)
    };
  }
  function sourceFilterFrom(item) {
    const source = item.sourceFilter && typeof item.sourceFilter === 'object' ? clone(item.sourceFilter) : {
      schemaVersion: 2, selectedTab: null, playerName: '', dropdownKeys: [], dropdownValues: [],
      dropdownIds: [], prices: [], searchImportPending: true
    };
    source.name = item.name;
    source.enabled = item.enabled !== false;
    source.playerName = String(item.playerName || '');
    if (Array.isArray(source.prices) && source.prices.length === 4) source.prices[3] = String(item.maxBin ?? '');
    source.purchaseMode = item.purchaseMode || 'live';
    source.buyLimit = Number(item.buyLimit) || 0;
    source.buyLimitAction = item.buyLimitAction || 'rotate';
    source.purchaseRules = clone(item.purchaseRules || []);
    source.futbinAction = item.futbinAction || 'off';
    source.futbinFallbackPrice = Number(item.futbinFallbackPrice) || 0;
    source.followUpAction = item.followUpAction === '' || item.followUpAction == null
      ? undefined
      : { type: Number(item.followUpAction), startPrice: Number(item.startPrice) || 0, buyNowPrice: Number(item.buyNowPrice) || 0 };
    source.followUpRules = clone(item.followUpRules || []);
    source.rotateAfter = { minutes: Number(item.rotateMinutes) || 0 };
    source.selectionChoice = item.selectionChoice || 'cheapest';
    source.buyAttempts = Number(item.buyAttempts) || 0;
    source.postWinDelaySeconds = Number(item.postWinDelaySeconds) || 0;
    source.freshnessMode = item.freshnessMode || 'run';
    source.maxMinBuyNowPrice = Number(item.resetPrice) || 0;
    source.maxBuyNowPriceLimit = Number(item.freshnessMaxBin) || 0;
    delete source.rotation;
    return source;
  }
  function snipingFilterFromPreview(data) {
    if (!Array.isArray(data.profiles) || !data.profiles.length) return null;
    const entries = data.profiles.map(item => ({ filter: sourceFilterFrom(item), playerRating: item.rating ?? '' }));
    const root = entries[0].filter;
    root.rotation = { mode: data.rotationMode || 'break', additional: entries.slice(1) };
    return root;
  }
  function snipingValues(data) {
    const run = data.run || {};
    const profile = Array.isArray(data.profiles) ? data.profiles[0] || {} : {};
    return {
      snipingSectionModes: run.modes ?? data.__extensionValues?.snipingSectionModes ?? null,
      sniperDurationMinValue: run.durationMin ?? null, sniperDurationMaxValue: run.durationMax ?? null,
      sniperDurationUnit: run.durationUnit ?? null,
      timeBetweenSearchesMin: run.intervalMin ?? null, timeBetweenSearchesMax: run.intervalMax ?? null,
      cardBoughtLimit: run.purchaseLimit ?? null, cardSeenLimit: run.seenLimit ?? null,
      searchLimit: run.searchLimit ?? null, searchResultLimit: run.resultsLimit ?? null,
      searchWithoutResultsLimit: run.emptySearchLimit ?? null, minimumCoinBalance: run.minimumCoins ?? null,
      maxBuyNowPriceLimit: run.freshnessMaxBin ?? null, maxMinBuyNowPrice: run.resetPrice ?? null,
      doRandomTaskBeforeBreak: run.randomTask ?? null, breakTaskClearSoldItems: run.clearSold ?? null,
      breakTaskRelistExpiredItems: run.relistUnsold ?? null, breakTaskRefreshCoinBalance: run.refreshCoins ?? null,
      priceRangeBreakEnabled: run.checkPriceRanges ?? null, priceRangeIncludeSnipedPlayers: run.includeNewlySniped ?? null,
      selectionChoice: profile.selectionChoice ?? null, defaultFollowUpAction: profile.followUpAction ?? null,
      followUpActionRules: profile.followUpRules ?? null,
      snipingFilter: snipingFilterFromPreview(data) ?? data.snipingFilter ?? data.__extensionValues?.snipingFilter ?? null, snipingFilterPlayerRating: profile.rating ?? null,
      skipBuyRules: profile.purchaseRules ?? null,
      breakFrequencyMin: run.breakFrequencyMin ?? null, breakFrequencyMax: run.breakFrequencyMax ?? null,
      breakFrequencyUnit: run.breakFrequencyUnit ?? null, breakDurationMin: run.breakDurationMin ?? null,
      breakDurationMax: run.breakDurationMax ?? null, breakDurationUnit: run.breakDurationUnit ?? null,
      buyAttempts: profile.buyAttempts ?? null, postWinDelaySeconds: profile.postWinDelaySeconds ?? null,
      transferListStateNotification: data.__extensionValues?.transferListStateNotification ?? null,
      filterRotatedNotification: data.__extensionValues?.filterRotatedNotification ?? null,
      shouldHideImages: data.hideImages ?? null, enableHeadlessBuy: data.buyMethod === 'buy',
      headlessVerboseNotifications: data.__extensionValues?.headlessVerboseNotifications ?? null,
      headlessMode: data.buyMethod ?? null,
      breakExecuteFollowUpActionRules: run.listMatchingCards ?? null
    };
  }
  function exportBlob(name, data, kind) {
    if (kind === 'bidding') return { name, bidderConfig: data.__withoutFilter ? null : clone(data) };
    const values = snipingValues(data);
    const blob = { name };
    for (const key of SNIPING_KEYS) blob[key] = Object.hasOwn(values, key) ? values[key] : null;
    return blob;
  }
  function importBlob(parsed, kind) {
    if (kind === 'bidding') {
      if (parsed.bidderConfig && typeof parsed.bidderConfig === 'object' && !Array.isArray(parsed.bidderConfig)) return clone(parsed.bidderConfig);
      if (Array.isArray(parsed.profiles) && parsed.loop) return clone(parsed);
      return { __withoutFilter: true };
    }
    if (Array.isArray(parsed.profiles) && parsed.run) return clone(parsed);
    const base = window.FutpilotPreviewSniping?.defaultState?.() || { profiles: [{ name: 'Filter 1' }], run: {} };
    base.__extensionValues = Object.fromEntries(SNIPING_KEYS.map(key => [key, Object.hasOwn(parsed, key) ? clone(parsed[key]) : null]));
    const run = base.run || (base.run = {});
    const map = {
      sniperDurationMinValue: 'durationMin', sniperDurationMaxValue: 'durationMax', sniperDurationUnit: 'durationUnit',
      timeBetweenSearchesMin: 'intervalMin', timeBetweenSearchesMax: 'intervalMax',
      cardBoughtLimit: 'purchaseLimit', cardSeenLimit: 'seenLimit', searchLimit: 'searchLimit',
      searchResultLimit: 'resultsLimit', searchWithoutResultsLimit: 'emptySearchLimit',
      minimumCoinBalance: 'minimumCoins', maxBuyNowPriceLimit: 'freshnessMaxBin',
      maxMinBuyNowPrice: 'resetPrice', doRandomTaskBeforeBreak: 'randomTask',
      breakTaskClearSoldItems: 'clearSold', breakTaskRelistExpiredItems: 'relistUnsold',
      breakTaskRefreshCoinBalance: 'refreshCoins', priceRangeBreakEnabled: 'checkPriceRanges',
      priceRangeIncludeSnipedPlayers: 'includeNewlySniped',
      breakFrequencyMin: 'breakFrequencyMin', breakFrequencyMax: 'breakFrequencyMax',
      breakFrequencyUnit: 'breakFrequencyUnit', breakDurationMin: 'breakDurationMin',
      breakDurationMax: 'breakDurationMax', breakDurationUnit: 'breakDurationUnit'
    };
    for (const [source, target] of Object.entries(map)) if (parsed[source] != null) run[target] = parsed[source];
    if (parsed.snipingSectionModes && typeof parsed.snipingSectionModes === 'object' && !Array.isArray(parsed.snipingSectionModes)) run.modes = clone(parsed.snipingSectionModes);
    if (parsed.shouldHideImages != null) base.hideImages = !!parsed.shouldHideImages;
    if (parsed.headlessMode != null) base.buyMethod = parsed.headlessMode;
    const first = base.profiles[0];
    if (parsed.selectionChoice != null) first.selectionChoice = parsed.selectionChoice;
    if (parsed.defaultFollowUpAction != null) first.followUpAction = parsed.defaultFollowUpAction;
    if (Array.isArray(parsed.followUpActionRules)) first.followUpRules = clone(parsed.followUpActionRules);
    if (Array.isArray(parsed.skipBuyRules)) first.purchaseRules = clone(parsed.skipBuyRules);
    if (parsed.buyAttempts != null) first.buyAttempts = parsed.buyAttempts;
    if (parsed.postWinDelaySeconds != null) first.postWinDelaySeconds = parsed.postWinDelaySeconds;
    if (parsed.breakExecuteFollowUpActionRules != null) run.listMatchingCards = !!parsed.breakExecuteFollowUpActionRules;
    if (parsed.snipingFilter && typeof parsed.snipingFilter === 'object') {
      const root = parsed.snipingFilter;
      const extras = Array.isArray(root.rotation?.additional) ? root.rotation.additional : [];
      const entries = [{ filter: root, playerRating: parsed.snipingFilterPlayerRating }, ...extras].slice(0, 15);
      base.profiles = entries.map((entry, index) => previewFilterFrom(entry.filter, entry.playerRating, index));
      base.selectedId = base.profiles[0].id;
      base.rotationMode = root.rotation?.mode || 'break';
      base.snipingFilter = clone(root);
    }
    return base;
  }
  function getActive(kind, fallback) {
    const saved = read(kind);
    return clone(saved.activeData || (saved.activeKey && saved.profiles.find(item => item.key === saved.activeKey)?.data) || fallback || {});
  }
  function saveActive(kind, data) {
    const saved = read(kind);
    saved.activeData = profilePayload(data, kind);
    const selected = saved.profiles.find(item => item.key === saved.activeKey);
    if (selected) selected.data = clone(data);
    write(kind, saved);
    return clone(saved.activeData);
  }
  function getActiveKey(kind) { return read(kind).activeKey; }
  function removeProfile(kind, key) {
    const saved = read(kind);
    const found = saved.profiles.some(item => item.key === key);
    if (!found) throw new Error('This profile is no longer saved. Reopen Saved Profiles.');
    saved.profiles = saved.profiles.filter(item => item.key !== key);
    if (saved.activeKey === key) saved.activeKey = null;
    write(kind, saved);
    return true;
  }
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function glyph(name) {
    const icon = element('span', 'afp-icon', ICONS[name]);
    icon.setAttribute('aria-hidden', 'true');
    return icon;
  }
  function button(text, icon, click, className) {
    const node = element('button', 'afp-button' + (className ? ' ' + className : ''));
    node.type = 'button';
    if (icon) node.append(glyph(icon));
    if (text) node.append(document.createTextNode(text));
    if (click) node.addEventListener('click', click);
    return node;
  }

  function mount(root, kind, options) {
    if (!(root instanceof Element)) throw new Error('Saved Profiles root is missing.');
    kind = mode(kind);
    options = options || {};
    let shownModal = null;
    let modalActivator = null;
    let copyTimeout = null;
    const feedback = (message, tone) => {
      if (typeof options.onFeedback === 'function') options.onFeedback(message, tone || 'info');
    };
    const current = () => clone(typeof options.getCurrent === 'function' ? options.getCurrent(kind) : getActive(kind, {}));
    const setCurrent = data => {
      if (typeof options.setCurrent === 'function') options.setCurrent(clone(data), kind);
    };
    const shell = root.closest('.af-demo-shell') || root;

    function closeModal() {
      if (!shownModal) return;
      shownModal.remove();
      shownModal = null;
      if (modalActivator && modalActivator.isConnected) modalActivator.focus();
      modalActivator = null;
    }
    function showModal({ title, description, confirmLabel, value, textarea, checkbox, errorPrefix, onConfirm }) {
      closeModal();
      modalActivator = document.activeElement;
      const backdrop = element('div', 'afp-modal-backdrop');
      const dialog = element('section', 'afp-modal');
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      const heading = element('h2', '', title);
      const titleId = 'afp-dialog-' + identifier();
      heading.id = titleId;
      dialog.setAttribute('aria-labelledby', titleId);
      dialog.append(heading, element('p', '', description));
      let field = null;
      if (value != null || textarea) {
        field = element(textarea ? 'textarea' : 'input', textarea ? 'afp-textarea' : 'afp-input');
        if (textarea) { field.rows = 6; field.setAttribute('aria-label', 'Profile data'); }
        else { field.type = 'text'; field.maxLength = MAX_NAME; field.setAttribute('aria-label', 'Profile name'); }
        field.value = value || '';
        dialog.append(field);
      }
      let check = null;
      if (checkbox) {
        const label = element('label', 'afp-check');
        check = document.createElement('input');
        check.type = 'checkbox';
        check.checked = true;
        label.append(check, document.createTextNode(checkbox));
        dialog.append(label);
      }
      const error = element('p', 'afp-modal-error');
      error.setAttribute('role', 'alert');
      error.hidden = true;
      dialog.append(error);
      const actions = element('div', 'afp-modal-actions');
      const yes = button(confirmLabel || 'Confirm', 'confirm', async () => {
        if (yes.disabled) return;
        error.hidden = true;
        try {
          yes.disabled = true;
          await onConfirm(field ? field.value : undefined, check ? check.checked : undefined);
          closeModal();
          render();
        } catch (issue) {
          const detail = issue && issue.message ? issue.message : 'Could not complete this action.';
          error.textContent = detail;
          error.hidden = false;
          yes.disabled = false;
          if (errorPrefix) feedback(errorPrefix + ': ' + detail, 'error');
          field?.focus();
        }
      }, 'afp-button-primary');
      const no = button('Cancel', 'close', closeModal);
      actions.append(yes, no);
      dialog.append(actions);
      backdrop.append(dialog);
      shell.append(backdrop);
      shownModal = backdrop;
      if (field) {
        field.addEventListener('input', () => {
          if (textarea) {
            try { const parsed = JSON.parse(field.value); yes.disabled = !parsed || typeof parsed !== 'object' || Array.isArray(parsed); }
            catch (_) { yes.disabled = true; }
          } else yes.disabled = !field.value.trim();
          error.hidden = true;
        });
        field.dispatchEvent(new Event('input'));
      }
      backdrop.addEventListener('click', event => { if (event.target === backdrop) closeModal(); });
      backdrop.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); closeModal(); }
        if (event.key === 'Tab') {
          const focusables = [field, check, yes, no].filter(Boolean).filter(item => !item.disabled);
          const index = focusables.indexOf(document.activeElement);
          if (event.shiftKey && index === 0) { event.preventDefault(); focusables.at(-1)?.focus(); }
          else if (!event.shiftKey && index === focusables.length - 1) { event.preventDefault(); focusables[0]?.focus(); }
        }
      });
      (field || yes).focus();
      return backdrop;
    }

    function createProfile() {
      showModal({
        title: 'New profile', description: 'Name this profile:', confirmLabel: 'Create profile',
        value: randomName(), checkbox: 'Copy current filter', errorPrefix: 'Could not save profile',
        onConfirm: (value, includeFilter) => {
          const saved = read(kind);
          const data = profilePayload(current(), kind);
          saved.profiles.push({ key: identifier(), name: nameOf(value), data: includeFilter ? data : stripFilter(data, kind) });
          write(kind, saved);
        }
      });
    }
    function importProfile() {
      showModal({
        title: 'Import profile', description: 'Paste the profile blob here:', confirmLabel: 'Import profile',
        textarea: true, value: '', errorPrefix: 'Could not import profile',
        onConfirm: value => {
          let parsed;
          try { parsed = JSON.parse(value); } catch (_) { throw new Error('Paste a valid profile.'); }
          if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) throw new Error('Paste a configuration object.');
          const name = Object.hasOwn(parsed, 'name') ? nameOf(parsed.name) : randomName();
          const data = importBlob(parsed.data && typeof parsed.data === 'object' && !Array.isArray(parsed.data) ? parsed.data : parsed, kind);
          const saved = read(kind);
          saved.profiles.push({ key: identifier(), name, data: profilePayload(data, kind) });
          write(kind, saved);
        }
      });
    }
    function ask(action, item) {
      const labels = { load: 'Load profile', overwrite: 'Overwrite profile', delete: 'Delete profile' };
      const descriptions = {
        load: kind === 'bidding' ? `Load ${item.name} into your current bidding settings?` : `Load ${item.name} as your active profile?`,
        overwrite: `Replace ${item.name} with your current settings?`,
        delete: `Delete ${item.name}? This cannot be undone.`
      };
      showModal({ title: labels[action], description: descriptions[action], confirmLabel: labels[action], errorPrefix: `Could not ${action} profile`, onConfirm: () => {
        const saved = read(kind);
        const target = saved.profiles.find(profile => profile.key === item.key);
        if (!target) throw new Error('This profile is no longer saved. Reopen Saved Profiles.');
        if (action === 'load') {
          saved.activeKey = target.key;
          saved.activeData = profilePayload(target.data, kind);
          write(kind, saved);
          setCurrent(target.data);
          feedback(`Loaded ${target.name}.`, 'success');
        } else if (action === 'overwrite') {
          target.data = profilePayload(current(), kind);
          write(kind, saved);
          feedback(`Overwrote ${target.name}.`, 'success');
        } else {
          saved.profiles = saved.profiles.filter(profile => profile.key !== target.key);
          if (saved.activeKey === target.key) saved.activeKey = null;
          write(kind, saved);
          feedback(`Deleted ${target.name}.`, 'success');
        }
      }});
    }
    async function copyProfile(item, control) {
      const saved = read(kind);
      const target = saved.profiles.find(profile => profile.key === item.key);
      if (!target) return feedback('Copy failed', 'error');
      const payload = JSON.stringify(exportBlob(target.name, target.data, kind), null, 2);
      const copyIcon = control.querySelector('.afp-icon');
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        control.disabled = true;
        await navigator.clipboard.writeText(payload);
        if (copyIcon) copyIcon.textContent = ICONS.confirm;
        control.lastChild.textContent = 'Copied!';
        feedback('Copied!', 'success');
      } catch (_) {
        if (copyIcon) copyIcon.textContent = ICONS.copy;
        control.lastChild.textContent = 'Copy failed';
        feedback('Copy failed', 'error');
      } finally {
        control.disabled = false;
        clearTimeout(copyTimeout);
        copyTimeout = setTimeout(() => {
          if (!control.isConnected) return;
          if (copyIcon) copyIcon.textContent = ICONS.copy;
          control.lastChild.textContent = 'Copy';
        }, 2500);
      }
    }
    function row(item) {
      const li = element('li', 'afp-profile');
      const heading = element('div', 'afp-profile-heading');
      heading.append(glyph('profile'));
      heading.lastChild.classList.add('afp-profile-icon');
      const name = element('input', 'afp-profile-name');
      name.type = 'text';
      name.maxLength = MAX_NAME;
      name.value = item.name;
      name.setAttribute('aria-label', `Name for ${item.name}`);
      let cancelled = false;
      name.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); name.blur(); }
        if (event.key === 'Escape') { event.preventDefault(); cancelled = true; name.value = item.name; name.blur(); }
      });
      name.addEventListener('blur', () => {
        if (cancelled) { cancelled = false; return; }
        if (name.value.trim() === item.name) return;
        try {
          const newName = nameOf(name.value);
          const saved = read(kind);
          const target = saved.profiles.find(profile => profile.key === item.key);
          if (!target) throw new Error('This profile is no longer saved. Reopen Saved Profiles.');
          target.name = newName;
          write(kind, saved);
          item.name = newName;
          feedback('Profile renamed.', 'success');
          name.value = newName;
          name.setAttribute('aria-label', `Name for ${newName}`);
          remove.setAttribute('aria-label', `Delete ${newName}`);
        } catch (issue) {
          name.value = item.name;
          feedback(issue.message || 'Could not rename profile.', 'error');
        }
      });
      const load = button('Load', 'open', () => ask('load', item), 'afp-load');
      const remove = button('', 'delete', () => ask('delete', item), 'afp-delete');
      remove.setAttribute('aria-label', `Delete ${item.name}`);
      remove.title = 'Delete profile';
      heading.append(name, load, remove);
      const actions = element('div', 'afp-profile-actions');
      actions.append(button('Overwrite', 'save', () => ask('overwrite', item)));
      const copy = button('', 'copy', null);
      copy.append(element('span', '', 'Copy'));
      copy.title = 'Copy profile';
      copy.setAttribute('aria-label', 'Copy profile');
      copy.addEventListener('click', () => copyProfile(item, copy));
      actions.append(copy);
      li.append(heading, actions);
      return li;
    }
    function render() {
      const saved = read(kind);
      const toolbar = element('div', 'afp-toolbar');
      toolbar.append(button('New', 'add', createProfile), button('Import', 'open', importProfile));
      if (options.showEditDefaults) {
        toolbar.append(button(kind === 'sniping' ? 'Edit Defaults' : 'Edit current settings', null, () => options.onEdit?.(kind), 'afp-button-primary'));
      }
      const list = element('ul', 'afp-list');
      for (const item of saved.profiles) list.append(row(item));
      root.className = 'afp-manager';
      root.replaceChildren(toolbar);
      if (!saved.profiles.length) root.append(element('p', 'afp-empty', 'No saved profiles yet.'));
      root.append(list);
      return root;
    }
    render();
    return { render, getActiveKey: () => getActiveKey(kind), getActive: fallback => getActive(kind, fallback), destroy: () => { closeModal(); clearTimeout(copyTimeout); } };
  }

  window.FutpilotPreviewProfiles = { mount, getActive, saveActive, getActiveKey, removeProfile };
})();
